document.addEventListener('DOMContentLoaded', function () {

  // 优惠弹窗显示
  const popupObserver = new MutationObserver(() => {
    const omnisendPopup = document.querySelector('#omnisend-forms-wrapper');
    if (omnisendPopup) {
      setTimeout(function () {
        omnisendPopup.classList.add('yg-init-finished');
      }, 8000);
      popupObserver.disconnect(); // 停止观察，防止重复触发
    }
  });

  // 监听整个 body
  popupObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          const revealLqip = () => img.classList.add('is-loaded');
          const isLqip = img.dataset.lqip === 'true';

          if (isLqip) {
            img.addEventListener('load', revealLqip, { once: true });
          }

          img.src = newImg.src;
          
          if (isLqip && img.complete) {
            if (typeof img.decode === 'function') {
              img.decode().catch(() => {}).finally(revealLqip);
            } else {
              revealLqip();
            }
          }

          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  window.YGVideoLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const videoHost = entry.target;

        if (videoHost.dataset.loaded == 'true') {
          observer.unobserve(videoHost);
          return;
        }

        // 获取内部的 template
        const template = videoHost.querySelector('template');

        if (!template) {
          observer.unobserve(videoHost);
          return;
        }

        // 将 template 的内容克隆为 DocumentFragment
        const fragment = template.content.cloneNode(true);

        // 先清空 yg-video 内部原有内容
        videoHost.innerHTML = '';

        // 将克隆的内容追加到 yg-video
        videoHost.appendChild(fragment);
        videoHost.dataset.loaded = 'true';

        videoHost.querySelectorAll('video').forEach(video => {
          video.setAttribute('playsinline', '');

          if (video.hasAttribute('autoplay')) {
            video.muted = true;
            video.defaultMuted = true;
            video.play().catch(() => {});
          }
        });

        observer.unobserve(videoHost);
      }
    });
  }, { 
    rootMargin: "120px 0px", // 预加载距离视口 120px 的视频
    threshold: 0.01,
  })

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGVideo extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置初始化逻辑
        this.loaderVideo()
    }

    loaderVideo () {
        // 这里放置自定义逻辑
        window.YGVideoLoader.observe(this)
    }
  }
  if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGPlayInline extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.addEventListener('click', this.playVideo.bind(this));
    }

    playVideo() {
      const template = this.querySelector('template');
      if (template) {
        // 隐藏当前播放按钮
        this.style.display = 'none';

        // 获取最近的媒体项容器
        const mediaItem = this.closest('.yg-media-item');
        if (mediaItem) {
          // 创建视频容器
          const videoContainer = document.createElement('div');
          videoContainer.className = 'yg-video-container';
          videoContainer.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #000;
            z-index: 3;
          `;

          // 插入视频内容
          videoContainer.innerHTML = template.innerHTML;

          // 设置视频样式
          const video = videoContainer.querySelector('video');
          const iframe = videoContainer.querySelector('iframe');

          if (video) {
            video.style.cssText = `
              width: 100%;
              height: 100%;
              object-fit: cover;
            `;
            video.removeAttribute('controls');
            video.setAttribute('loop', 'true');
            video.setAttribute('autoplay', 'true');
            video.setAttribute('muted', 'true');
          }

          if (iframe) {
            iframe.style.cssText = `
              width: 100%;
              height: 100%;
              border: none;
            `;
          }

          mediaItem.appendChild(videoContainer);
        }
      }
    }

    resetVideo() {
      const mediaItem = this.closest('.yg-media-item');
      if (mediaItem) {
        const videoContainer = mediaItem.querySelector('.yg-video-container');
        if (videoContainer) {
          videoContainer.remove();
        }
      }
      this.style.display = 'flex';
    }
  }


  if (!window.customElements.get('yg-play-inline')) {
    window.customElements.define('yg-play-inline', YGPlayInline);
  }


  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    get getCurrentSlidesPerView() {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'centered-slides', 'mousewheel', 'direction', 'scrollbar', 'progressbar', 'grid'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          type: this['progressbar'] ? 'progressbar' : 'bullets',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        } : false,
        scrollbar: this['scrollbar'] ? {
          el: ".swiper-scrollbar",
          hide: true,
        } : false,
        grid: this['grid'] ? {
          fill: 'row',
          rows: 2,
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        mousewheel: this['mousewheel'] ? {
          releaseOnEdges: true,
        } : false,
        direction: this['direction'] ? this['direction'] : "horizontal",
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }
  class YGQuetion extends HTMLElement {
    constructor() {
      super()
      this.$btnList = this.btnList
      this.$itemList = this.itemList
    }
    get btnList() {
      if (!this.$btnList) {
        this.$btnList = this.querySelectorAll('.yg-item__btn')
      }
      return this.$btnList
    }
    get itemList() {
      if (!this.$itemList) {
        this.$itemList = this.querySelectorAll('.yg-item__answer')
      }
      return this.$itemList
    }
    handClick(e, i) {
      if (this.$itemList[i].classList.contains('active')) {
        this.$itemList[i].classList.remove('active')
        this.$btnList[i].classList.remove('active')
      } else {
        this.$itemList[i].classList.add('active')
        this.$btnList[i].classList.add('active')
      }
    }
    connectedCallback() {
      this.$btnList.forEach(($item, i) => $item.addEventListener('click', (e) => this.handClick(e, i)))
      // this.$btnList.forEach(($item,i)=>this.handClick( $item,i))
    }

  }
  if (!window.customElements.get('yg-quetion')) {
    window.customElements.define('yg-quetion', YGQuetion)
  }
  class YGToggle extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {

      const section = this.closest(".shopify-section")
      this.allButtons = section.querySelectorAll('.yg-toggle-button');
      this.allContents = section.querySelectorAll('.yg-toggle-content');

      this.showmore_text = this.getAttribute('data-more');
      this.showless_text = this.getAttribute('data-less');
      this.button = this.querySelector('.yg-toggle-button');
      this.content = this.querySelector('.yg-toggle-content');

      if (this.allButtons && this.allContents) {
        this.button.addEventListener('click', () => {
          const isActive = this.button.classList.contains("active");

          this.allButtons.forEach(btn => {
            btn.classList.toggle('active', !isActive);
            const p = btn.querySelector('p');
            if (p) {
              setTimeout(() => {
                p.textContent = !isActive ? this.showless_text : this.showmore_text;
              }, 200);
            }
          });

          this.allContents.forEach(content => {
            content.classList.toggle('open', !isActive);
            if (!isActive) {
              const scrollHeight = content.scrollHeight;
              content.style.maxHeight = scrollHeight + 'px';
            }
            else {
              content.style.maxHeight = '0px';
            }
          });
        });
        if (this.content.classList.contains('open')) {
          this.content.style.maxHeight = this.content.scrollHeight + 'px';
        }
      }
    }

  }

  if (!customElements.get('yg-toggle')) {
    customElements.define('yg-toggle', YGToggle);
  }
  class YGVideoListSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }
    initSwiper() {
      const swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: this.getAttribute('data-enable-autoplay') === 'true' ? {
          delay: parseInt(this.getAttribute('data-autoplay-delay')) * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: 1.7,
            spaceBetween: 32,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
          progressbarOpposite: false,
        },
      });
    }
  }

  if (!window.customElements.get('yg-video-list-swiper')) {
    window.customElements.define('yg-video-list-swiper', YGVideoListSwiper);
  }

  class YGReviewSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 16,
        autoplay:
          this.getAttribute('data-enable-autoplay') === 'true'
            ? {
                delay: parseInt(this.getAttribute('data-autoplay-delay')) * 1000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
              }
            : false,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
          progressbarOpposite: false,
        },
      });
    }
  }

  if (!window.customElements.get('yg-review-swiper')) {
    window.customElements.define('yg-review-swiper', YGReviewSwiper);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  function fixTaiwanHomeZeissSlideLink() {
    if (!window.location.pathname.toLowerCase().startsWith('/zh-tw')) return;

    const zeissLensUrl = '/zh-tw/products/bleequp-%E8%94%A1%E5%8F%B8%E9%8F%A1%E7%89%87';
    const heroSlide = document.querySelector('#block-image_FeDE4J');

    if (heroSlide && heroSlide.matches('a')) {
      heroSlide.setAttribute('href', zeissLensUrl);
    }
  }

  fixTaiwanHomeZeissSlideLink();
  window.addEventListener('pageshow', fixTaiwanHomeZeissSlideLink);
})
